import { useId as e } from "react";
//#region lib/components/FormField/useFormField.tsx
function t({ id: t, helpText: n, errorMessage: r }) {
	let i = e(), a = t ?? i, o = !!r, s = !!n, c = s ? `${a}-help` : void 0, l = r ? `${a}-error` : void 0;
	return {
		fieldId: a,
		hasError: o,
		hasHelpText: s,
		describedBy: [c, l].filter(Boolean).join(" ") || void 0,
		helpTextId: c,
		errorMessageId: l
	};
}
//#endregion
export { t as useFormField };
